import PanelOptionMixin from '../mixin';
import dragMixin from '@/mixins/drag';

import Icon from '@svgIcons/dashboard/setting_creative_cnt.svg';

import * as C from '../styles';
import * as S from './styles';

import { VERTICAL_SPACER } from '@/styles/common.styled.component';
import Dropdown from '@/components/Common/Dropdown';

const COMMON_HEIGHT = {
    menuItemHeight: '32px',
};

const CNT_OPTIONS = [1, ...Array.from({ length: 10 }, (v, i) => (i + 1) * 5)];

export default {
    name: 'CreativeCntOption',
    mixins: [PanelOptionMixin, dragMixin({ cursorNormal: 'grab' })],
    props: {
        creativeCnt: {
            type: Number,
            require: true,
        },
    },
    computed: {},
    methods: {
        renderContent() {
            return (
                <S.Wrapper>
                    <div ref="dropdownWrapper">
                        <Dropdown
                            options={CNT_OPTIONS}
                            formatter={R.identity}
                            customStyles={COMMON_HEIGHT}
                            onInput={({ value }) => {
                                this.$emit('update', value);
                            }}
                            value={this.creativeCnt}
                            getPopupContainer={() => this.$refs.dropdownWrapper}
                        />
                    </div>
                    <VERTICAL_SPACER amount={12} />
                </S.Wrapper>
            );
        },
    },
    render() {
        const { wrapOptions, renderContent } = this;

        return (
            <C.ComponentWrapper>
                {wrapOptions({
                    children: renderContent(),
                    title: this.$t('NEW_DASHBOARD.setting_option_creative_cnt'),
                    icon: <Icon class="metric-icon" />,
                    hasEditBtn: false,
                })}
            </C.ComponentWrapper>
        );
    },
};
